import { useContext } from 'react'

import { ThemeContext } from '@space-lib/context/theme'
import type { ThemeContextProps } from '@space-lib/context/theme/types'

export const useThemeContext = () => {
  return useContext<ThemeContextProps>(ThemeContext)
}
